import { NumberUtils } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

import { RolloutData } from '../../types';

const formatReach = (reach: string | undefined): string => {
  if (!reach) return 'Not set';
  return NumberUtils.formatRatioAsPercentage(parseFloat(reach), 0);
};

const ReachChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as RolloutData | null;
  const newValue = change.newValue as RolloutData | null;

  const oldReach = oldValue?.reach;
  const newReach = newValue?.reach;

  if (oldReach === newReach) {
    return null;
  }

  const oldFormatted = oldReach ? formatReach(oldReach) : undefined;
  const newFormatted = formatReach(newReach);

  return (
    <ActivityItem.Section label="Updated reach">
      <ActivityTagItem
        oldValue={oldFormatted}
        newValue={newFormatted}
        ariaLabel="Reach percentage"
      />
    </ActivityItem.Section>
  );
};

export const REACH_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension({
  id: 'rollout-reach-change',
  predicate: ({ change }) => {
    if (change.fieldPath !== '/module_data/rollout') {
      return false;
    }
    const oldValue = change.oldValue as RolloutData | null;
    const newValue = change.newValue as RolloutData | null;
    return oldValue?.reach !== newValue?.reach;
  },
  render: ReachChangeRender,
});
